import { isMobileScreen } from '@apply/ui';

export interface ICCAStartDateCellProps {
    iccaStart: string | undefined;
}

export const ICCAStartDateCell: React.FC<ICCAStartDateCellProps> = ({ iccaStart }) => {
    const mobileScreen = isMobileScreen();
    return (
        <>
            {iccaStart && (
                <div className={`activatedBrokerReferralsTable-iccaStartDate ${mobileScreen ? 'mobile' : ''}`}>
                    <div className='activatedBrokerReferralsTable-iccaStartDate-value'>{iccaStart}</div>
                </div>
            )}
        </>
    );
};
